export const ALL_EMAIL_TYPES_LABEL = 'All Email Types';
